import React, {Component, useState} from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    Accordion,
    AccordionItem,
    AccordionSkeleton, Button,
    MultiSelect,
    RadioButton,
    Dropdown
} from "carbon-components-react";
import {Undo16} from "@carbon/icons-react";
import BasicDateTimePicker from "../DatePicker";

export default class extends Component {

    state = {
        isOppenedSubmit: false,
        skuisOpend: true,
        skuDetailsisOpenend: false,
        form: {
            dateStart: "",
            dateEnd: "",
            business_unit: [],
            report: [],
            category1: [],
            category2: [],
            category3: []
        }
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }

    removeDuplicates(array, key) {
        return array.reduce((accumulator, element) => {
            if (!accumulator.find(el => el[key] === element[key])) {
                accumulator.push(element);
            }
            return accumulator;
        }, []);
    }

    async handleChange(e) {
        //const name = event.target.name;
        //console.log(name);
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
        //console.log(this.state);
    }

    handleSubmit = (e) => {
        //e.preventDefault();
        //Your code here. For example,
        //alert("Form submitted");
        //console.log(this.state.form);
        //localStorage.setItem('formFilter', JSON.stringify(this.state.form));
        window.location.href = '/ij/cockpit_preview'
    }

    handleSetClear = (e) => {
        e.preventDefault();
        this.setState({

            form: {
                dateStart: "",
                dateEnd: "",
                sku: [],
                brand: [],
                category: [],
                hero: [],
                majorCategory: [],
                abcd: [],
                subCategory: [],
                plcLocal: [],
                chanel: [],
            }
        });

    }


    render() {
        const {data, isLoading} = this.props;
        const {form, skuisOpend, skuDetailsisOpenend} = this.state;
        let sku = [];
        let brand = [];
        let category = [];
        let hero = [];
        let majorCategory = [];
        let abcd = [];
        let subCategory = [];
        let plcLocal = [];
        if (data.length > 0) {
            data.forEach(dados => {
                sku.push({id: dados['sku'], text: dados['sku']});
                if (dados['marca'] !== "")
                    brand.push({id: dados['marca'], text: dados['marca']});
                if (dados['category_sku'] !== "")
                    category.push({id: dados['category_sku'], text: dados['category_sku']});
                if (dados['hero'] !== "")
                    hero.push({id: dados['hero'], text: dados['hero']});
                if (dados['categoria_principal_sku'] !== "")
                    majorCategory.push({id: dados['categoria_principal_sku'], text: dados['categoria_principal_sku']});
                if (dados['abcd'] !== "")
                    abcd.push({id: dados['abcd'], text: dados['abcd']});
                if (dados['sub_categoria_sku'] !== "")
                    subCategory.push({id: dados['sub_categoria_sku'], text: dados['sub_categoria_sku']});
                if (dados['plc_localsku'] !== "")
                    plcLocal.push({id: dados['plc_localsku'], text: dados['plc_local']});
            });
            sku = this.removeDuplicates(sku, 'id');
            brand = this.removeDuplicates(brand, 'id');
            category = this.removeDuplicates(category, 'id');
            hero = this.removeDuplicates(hero, 'id');
            majorCategory = this.removeDuplicates(majorCategory, 'id');
            abcd = this.removeDuplicates(abcd, 'id');
            subCategory = this.removeDuplicates(subCategory, 'id');
            plcLocal = this.removeDuplicates(plcLocal, 'id');
        }
        let step2 = false;
        let step3 = true;
        let buttonD = false;
        if (form.dateStart !== "" && form.dateEnd !== "") {
            step2 = false;
        }

        return (
            <div>
                <form>
                    <div className="bx--row bx--fieldset">
                        <div className="bx--col-md-6 bx--col-lg-7 content-pt-1"><p>To generate a report you need to
                            select Period and Filters options.</p></div>
                        <div className="bx--col-md-2 bx--col-lg-3 content-align-center">
                            <Button onClick={e => {
                                this.handleSubmit(e)
                            }} kind='primary'
                                    disabled={buttonD}>Generate
                                report</Button>
                            <span className="content-ml-10">
                            <Button
                                hasIconOnly
                                renderIcon={Undo16}
                                tooltipAlignment="center"
                                tooltipPosition="bottom"
                                iconDescription="Reset"
                                kind='secondary'
                                onClick={e => {
                                    this.handleSetClear(e)
                                }}
                            />
                            </span>
                        </div>
                    </div>
                    {isLoading ? (
                        <AccordionSkeleton/>
                    ) : (
                        <Accordion className="bx--accordion-80">
                            <AccordionItem open="true" title="1. Period">
                                <div className={"clearfix"}>
                                    <div className={"div-date"}>
                                        <BasicDateTimePicker/>
                                    </div>
                                    <div className={"div-date"}>

                                    </div>
                                </div>
                            </AccordionItem>
                            <AccordionItem open={true} title="2. Filters">
                                <div className="clearfix">
                                    <div className="row bx--col-padding bx--row-padding" style={{paddingLeft: "20px"}}>

                                        <div className="col-md-3 bx--col-padding bx--row-padding">
                                            <Dropdown
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="business-unit"
                                                name="business-unit"
                                                label="Business Unit"
                                                placeholder="Business Unit"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={[
                                                    {
                                                        id: 'Business Unit',
                                                        text: 'Business Unit'
                                                    }
                                                ]}
                                                initialSelectedItems={form.business_unit}
                                                itemToString={(item) => (item ? item.text : '')}

                                            />
                                        </div>
                                        <div className="col-md-3 bx--col-padding bx--row-padding">
                                            <Dropdown
                                                useTitleInItem={false}
                                                id="report"
                                                name="report"
                                                label="Report"
                                                placeholder="Report"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={[
                                                    {
                                                        id: 'Balance Sheet',
                                                        text: 'Balance Sheet'
                                                    },
                                                    {
                                                        id: 'Working Capital',
                                                        text: 'Working Capital'
                                                    }
                                                ]}
                                                itemToString={(item) => (item ? item.text : '')}
                                            />
                                        </div>
                                        <div className="col-md-3 bx--col-padding bx--row-padding">
                                            <Dropdown
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="category1"
                                                name="category1"
                                                label="Category 1"
                                                placeholder="Category 1"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={[
                                                    {
                                                        id: 'No-current Assests',
                                                        text: 'No-current Assests'
                                                    },
                                                    {
                                                        id: 'Current Assests',
                                                        text: 'Current Assests'
                                                    },
                                                    {
                                                        id: 'Current Liabilities',
                                                        text: 'Current Liabilities'
                                                    },
                                                    {
                                                        id: 'No-current Liabilities',
                                                        text: 'No-current Liabilities'
                                                    },
                                                    {
                                                        id: 'Equity',
                                                        text: 'Equity'
                                                    }
                                                ]}
                                                initialSelectedItems={form.category1}
                                                itemToString={(item) => (item ? item.text : '')}

                                            />
                                        </div>
                                        <div className="col-md-3 bx--col-padding bx--row-padding">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="category2"
                                                name="category2"
                                                label="Category 2"
                                                placeholder="Category 2"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={[
                                                    {
                                                        id: 'Goodwill at cost',
                                                        text: 'Goodwill at cost'
                                                    },
                                                    {
                                                        id: 'Goodwill accumulated impairment',
                                                        text: 'Goodwill accumulated impairment'
                                                    },
                                                    {
                                                        id: 'Indefinite lived intangibles',
                                                        text: 'Indefinite lived intangibles'
                                                    },
                                                    {
                                                        id: 'Finite lived intangibles',
                                                        text: 'Finite lived intangibles'
                                                    },
                                                    {
                                                        id: 'Software',
                                                        text: 'Software'
                                                    }
                                                ]}
                                                initialSelectedItems={form.category2}
                                                itemToString={(item) => (item ? item.text : '')}

                                            />
                                        </div>
                                        <div className="col-md-3 bx--col-padding bx--row-padding">
                                            <MultiSelect.Filterable
                                                disabled={skuDetailsisOpenend}
                                                useTitleInItem={false}
                                                id="category3"
                                                name="category3"
                                                label="Category 3"
                                                placeholder="Category 3"
                                                invalid={false}
                                                invalidText="Invalid Selection"
                                                items={[
                                                    {
                                                        id: 'TRADEMARK AT COST',
                                                        text: 'Trademark-Transfer Held For Sales'
                                                    },
                                                    {
                                                        id: 'Trademark-Transfer Held For Sales',
                                                        text: 'Trademark-Transfer Held For Sales'
                                                    },
                                                    {
                                                        id: 'OTHER INTANGIBLES AT COST',
                                                        text: 'OTHER INTANGIBLES AT COST'
                                                    },
                                                    {
                                                        id: 'TRADEMARK ACCUMULATED IMP',
                                                        text: 'TRADEMARK ACCUMULATED IMP'
                                                    },
                                                    {
                                                        id: 'OT INA ACCUMULATED IMP',
                                                        text: 'OT INA ACCUMULATED IMP'
                                                    }
                                                ]}
                                                initialSelectedItems={form.category3}
                                                itemToString={(item) => (item ? item.text : '')}
                                                onChange={(evt) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'category3': evt.selectedItems.map((item) => {
                                                                return item.id
                                                            })
                                                        }
                                                    }))
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </AccordionItem>
                        </Accordion>
                    )}
                </form>
            </div>
        );
    }
}
